import { defineStore } from 'pinia';
import { reactive, ref, markRaw } from 'vue';
import CreatedAtFilter from '@/components/apiEvents/CreatedAtFilter.vue';
import MadeByFilter from '@/components/apiEvents/MadeByFilter.vue';
import ApiEventFilter from '@/components/apiEvents/ApiEventFilter.vue';
import StatusFilter from '@/components/apiEvents/StatusFilter.vue';

export const useApiEventsLogComponentStore = defineStore('apiEventsLogComponent', () => {
    const filters = reactive([
        markRaw(CreatedAtFilter),
        markRaw(MadeByFilter),
        markRaw(ApiEventFilter),
        markRaw(StatusFilter),
    ]);
    const columns = ref([
        {title: 'ID', key: 'event.id', sortable: false, width: '6.7%', priority: 100},
        {title: 'Дата и время', key: 'event.createdAt', sortable: false, width: '9.6%', priority: 80},
        {title: 'Наименование клиента API', key: 'token.name', sortable: false, width: '25.5%', priority: 60},
        {title: 'Тип запроса', key: 'event.event.name', sortable: false, width: '14.4%', priority: 40},
        {title: 'Результат', key: 'event.success', sortable: false, width: '11.6%', priority: 20},
        {title: '', sortable: false, width: '7%', priority: 0}
    ]);

    function registerFilter(filter) {
        filters.push(markRaw(filter));
    }

    function getFilters() {
        return filters;
    }

    function addColumn(column) {
        columns.value.push(column);
    }

    function getColumnsHeaders() {
        return columns.value.sort(
            (a, b) => b.priority - a.priority
        );
    }

    return {
        registerFilter,
        getFilters,
        addColumn,
        getColumnsHeaders,
    };
});
